<script setup lang="ts">
  import { IconCIS } from '@ui-kit';
  import { ScanModal } from '../ScanModal';

  const emit = defineEmits<{
    'click:back': [value: void];
    'click:btn': [value: void];
  }>();
</script>

<template>
  <ScanModal
    :title="$t('КИЗ от другого товара')"
    :subtitle="$t('Вы уверены, что отсканировали КИЗ с первоначальной этикетки?')"
    :btnTitle="$t('Да, этот КИЗ от моего товара')"
    @click:back="emit('click:back')"
    @click:btn="emit('click:btn')"
    data-testid="incorrect-cis"
  >
    <template #icon>
      <IconCIS />
    </template>
    <slot />
  </ScanModal>
</template>